import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54e00fa9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54e00fa9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e00fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e00fa9')) {
      api.createRecord('54e00fa9', component.options)
    } else {
      api.reload('54e00fa9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=54e00fa9&scoped=true", function () {
      api.rerender('54e00fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageUpload2/index.vue"
export default component.exports